import React, { useState, useEffect, useReducer } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
} from "@mui/material";
import { get, post } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import { APIStatusDialog } from "./APIStatusDialog";
import Autocomplete from "@mui/material/Autocomplete";
import { I18n } from "aws-amplify/utils";
const reducer = (lastState, action) => {
  switch (action.type) {
    case "DATA_RECEIVED":
      const alarmTypes = Array.isArray(action.value) ? action.value : [];
      return { alarmTypes: alarmTypes, fetched: true };
    default:
      return lastState;
  }
};

function EncodeDialog({ open, onClose, language, selectedRows }) {
  const [selectedValue, setSelectedValue] = useState(null);
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  const [state, dispatch] = useReducer(reducer, {
    alarmTypes: [],
    fetched: false,
  });

  const handleSave = async () => {
    if (selectedValue && selectedRows.length > 0) {
      try {
        setApiStatus({
          open: true,
          status: "pending",
          message: I18n.get("Encoding the alarm text"),
        });
        const alarmTypeId = selectedValue.id; // Get the selected alarm type ID
        const alarmIds = selectedRows; // IDs of selected rows

        const restOperation = await tlmPostNewCodifiedAlarmMap(
          alarmTypeId,
          alarmIds
        );
        const { body, statusCode } = await restOperation.response;
        const response = await body.json();
        if (statusCode === 200) {
          setApiStatus({
            open: true,
            status: "success",
            message: I18n.get("Alarm Text encoded correctly"),
          });
          dispatch({ type: "DATA_RECEIVED", value: response });
        } else {
          setApiStatus({
            open: true,
            status: "error",
            message: I18n.get("Failed to encode the alarm text"),
          });
        }

        setTimeout(() => {
          setApiStatus((prevState) => ({ ...prevState, open: false }));
          setTimeout(() => {
            onClose();
          }, 500);
        }, 2000);
      } catch (error) {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to encode the alarm text"),
        });

        setTimeout(() => {
          setApiStatus((prevState) => ({ ...prevState, open: false }));
          setTimeout(() => {
            onClose();
          }, 500);
        }, 2000);
      }
    } else {
      console.warn(
        "Please select an alarm type and ensure that rows are selected."
      );
    }
  };

  const tlmGetAlarmTypes = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/alarm/types",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            language: language,
          },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  useEffect(() => {
    if (open) {
      tlmGetAlarmTypes();
    }
  }, [open, language]);

  const tlmPostNewCodifiedAlarmMap = async (alarmTypeId, alarmIds) => {
    try {
      const restOperation = post({
        apiName: "TelemonitoringAPI",
        path: "/alarm/map/new",
        options: {
          body: alarmIds,
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            alarm_type_id: alarmTypeId,
          },
        },
      });
      return restOperation;
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{I18n.get("Encode")}</DialogTitle>
      <DialogContent sx={{ minHeight: "100px" }}>
        <DialogContentText id="alert-dialog-description">
          {I18n.get(
            "Select the Alarm Code with which you want to decode the selected alarm messages"
          )}
        </DialogContentText>
        <Autocomplete
          options={state.alarmTypes.sort(
            (a, b) => b.type_severity - a.type_severity
          )}
          getOptionLabel={(option) =>
            `${option.type_severity} - ${option.description}`
          }
          onChange={(event, newValue) => setSelectedValue(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={I18n.get("Alarm Codes")}
              variant="outlined"
              fullWidth
            />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          noOptionsText="No options"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {I18n.get("Cancel")}
        </Button>
        <Button onClick={handleSave} color="primary">
          {I18n.get("Save")}
        </Button>
      </DialogActions>
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
    </Dialog>
  );
}

export default EncodeDialog;
